export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    exercises: []
  },
  action,
) {

  // Set payload specifics
  switch (action.type) {
    case 'SET_WEATHEROBS_EXERCISES_FULFILLED': {
      return {
        ...state,
        exercises: action.payload
      };
    }
    case 'SET_WEATHEROBS_EXERCISE_FULFILLED': {
      const exercises = state.exercises;
      const idx = exercises.findIndex(exercise => exercise.id === action.payload.id);
      if (idx === -1)
        exercises.push(action.payload);
      else
      exercises[idx] = action.payload;

      return {
        ...state,
        exercises
      };
    }
    default:
      break;
  }
  return state;
}
